




import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import * as echartsImport from '../../../../../static/lib/echarts.min.js';
let echarts: any = echartsImport;

import ecProgressImport from '../../../../dv-pure-render/ec-progress/ec-progress.js';
let ecProgress: any = ecProgressImport;

@Component
export default class App extends Vue {
    @Prop({default: '无数值'})
    value: any;

    get v () {return parseInt(this.value) || 0}

    @Prop({default: '无数值'})
    tip: any;

    @Prop({default: false})
    tipNoValue: any;

    @Prop()
    bg: any

    @Watch('value')
    onListChange (value, oldVal) {
        this.drawProgress();
    }

    drawProgress () {
        ecProgress({echarts,
            dom: this.$refs.personProgressWrap,
            tip: this.tip,
            value: this.v,
            bg: this.bg,
            tipNoValue: this.tipNoValue});
    }

    mounted () {
        this.drawProgress();
    }
}
